import { useCallback } from "react";
import { useNavigate } from "react-router";

function canNavigateBack(): boolean {
  const historyIndex = window.history.state?.idx;
  if (typeof historyIndex === "number") {
    return historyIndex > 0;
  }
  return window.history.length > 1;
}

/** Navigate to the previous in-app page, or `fallback` when there is no history. */
export function useGoBack(fallback = "/") {
  const navigate = useNavigate();

  return useCallback(() => {
    if (canNavigateBack()) {
      navigate(-1);
    } else {
      navigate(fallback);
    }
  }, [navigate, fallback]);
}
